import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e5228f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "categories-container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "categoryText" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-fenlei" }, null, -1))
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "count" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.categoryList, (category) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "category-card",
        key: category.id,
        onClick: ($event: any) => ($setup.handleCardClick(category.id,category.articleCount))
      }, [
        _createElementVNode("span", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(category.categoryName), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createTextVNode("文章数："),
          _createElementVNode("span", _hoisted_6, _toDisplayString(category.articleCount), 1)
        ])
      ], 8, _hoisted_2))
    }), 128))
  ]))
}